import errorModule from 'src/js/modules/error';
import { serviceProvider } from '@yola/subscription-manager-js';
import status from 'src/js/modules/status';
import user from 'src/js/modules/user';
import statusNames from '../constants/status-names';

const fetchEcommercePackages = () => async (dispatch, getState) => {
  const state = getState();
  const availableSubscriptionTypes = user.selectors.getAvailableSubscriptionTypes(state);

  dispatch(status.actions.setStatus(statusNames.ECOMMERCE_PACKAGES, status.constants.LOADING));

  try {
    await serviceProvider.fetchEcommercePlans(availableSubscriptionTypes);
    dispatch(status.actions.setStatus(statusNames.ECOMMERCE_PACKAGES, status.constants.SUCCEEDED));
  } catch (error) {
    errorModule.operations.catchError(error);
    console.error(error);
    dispatch(status.actions.setStatus(statusNames.ECOMMERCE_PACKAGES, status.constants.FAILED));
  }
};

export default fetchEcommercePackages;
